import {OfferItem} from "@/components/model/offer-item";
import {http} from "@/components/http/http.service";

class OfferService {
    loadAll(): Promise<OfferItem[]> {
        return http.get<OfferItem[]>('/api/offer-items/active');
    }
}

export const offer = new OfferService();
